import { routes } from "../../routers/routes";
import { MenuItem } from "../../types/Layout";

export const menuList: MenuItem[] | undefined = [
  {
    title: "Users",
    Items: [
      {
        id: 2,
        title: "All users",
        type: "link",
        icon: "icon-person",
        url: routes.AllUsers,
      },
      {
        id: 3,
        title: "Add Devices",
        type: "link",
        icon: "icon-person",
        url: routes.AddDevice,
      },
    ],
  },
];
